/**
 * GMV Idomoo form – submit: 1x POST ke backend unified, lalu redirect.
 * Backend URL dari section setting "Backend API URL (unified)".
 * Form class idomoo-form--triple-api; wrapper punya data-backend-unified-url, data-success-redirect-url.
 */
(function () {
  'use strict';

  /**
   * Payload untuk POST ke backend unified API.
   * Sama dengan contoh curl: first_name, last_name, email, jersey_name, jersey_number, country, consent_*.
   */
  function getPayload(form) {
    var fd = new FormData(form);
    var jerseyNumber = (fd.get('jersey_number') || '').trim().replace(/\D/g, '').slice(0, 2);
    /* Same rule as CustomNameNumber.vue: only basic Latin letters / spaces /
       apostrophes / hyphens / periods / tildes, uppercased, max 9 characters. */
    var jerseyName = (fd.get('jersey_name') || '')
      .replace(/[^A-Za-z '.~-]/g, '')
      .toUpperCase()
      .trim()
      .slice(0, 9);
    return {
      first_name: (fd.get('first_name') || '').trim(),
      last_name: (fd.get('last_name') || '').trim(),
      email: (fd.get('email') || '').trim(),
      mode: (fd.get('mode') || '').trim(),
      jersey_name: jerseyName,
      jersey_number: jerseyNumber,
      country: (fd.get('country') || '').trim(),
      consent_marketing: fd.get('consent_marketing') === '1',
      consent_profiling: fd.get('consent_profiling') === '1',
      consent_third_party: fd.get('consent_third_party') === '1'
    };
  }

  function getFormMessages(wrapper) {
    var ds = (wrapper && wrapper.dataset) || {};
    return {
      firstNameRequired: ds.errorFirstNameRequired || 'First name is required.',
      lastNameRequired: ds.errorLastNameRequired || 'Last name is required.',
      emailRequired: ds.errorEmailRequired || 'Email is required.',
      emailInvalid: ds.errorEmailInvalid || 'Please enter a valid email address.',
      jerseyNumberNumeric: ds.errorJerseyNumberNumeric || 'Jersey number must be a number.',
      videoUrlMissing: ds.errorVideoUrlMissing || 'Something wrong, please try again'
    };
  }

  function validatePayload(payload, messages) {
    var errors = [];
    if (!payload.first_name) errors.push({ field: 'first_name', message: messages.firstNameRequired });
    if (!payload.last_name) errors.push({ field: 'last_name', message: messages.lastNameRequired });
    if (!payload.email) {
      errors.push({ field: 'email', message: messages.emailRequired });
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      errors.push({ field: 'email', message: messages.emailInvalid });
    }
    if (payload.jersey_number && !/^\d+$/.test(payload.jersey_number)) errors.push({ field: 'jersey_number', message: messages.jerseyNumberNumeric });
    return errors.length ? errors : null;
  }

  function clearFieldErrors(form) {
    form.querySelectorAll('.idomoo-form__field-error').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
    form.querySelectorAll('.idomoo-form__input, .idomoo-form__select').forEach(function (el) {
      el.setAttribute('aria-invalid', 'false');
    });
  }

  function showFieldError(form, fieldName, message) {
    var fieldWrap = form.querySelector('.idomoo-form__field[data-field="' + fieldName + '"]');
    if (!fieldWrap) return;
    var errEl = fieldWrap.querySelector('.idomoo-form__field-error');
    var input = fieldWrap.querySelector('input, select');
    if (errEl) {
      errEl.textContent = message || '';
      errEl.hidden = !message;
    }
    if (input && message) input.setAttribute('aria-invalid', 'true');
  }

  function showMessage(form, type, text) {
    var el = form.querySelector('.idomoo-form__message--api');
    if (!el) return;
    el.hidden = false;
    el.textContent = text || '';
    el.className = 'idomoo-form__message idomoo-form__message--api idomoo-form__message--' + type;
  }

  function hideMessage(form) {
    var el = form.querySelector('.idomoo-form__message--api');
    if (el) el.hidden = true;
  }

  function bindJerseyNumberNumericOnly(form) {
    var input = form.querySelector('input[name="jersey_number"]');
    if (!input) return;

    function sanitize() {
      var cleaned = (input.value || '').replace(/\D/g, '').slice(0, 2);
      if (input.value !== cleaned) input.value = cleaned;
    }

    input.addEventListener('input', sanitize);
    input.addEventListener('paste', function () {
      setTimeout(sanitize, 0);
    });
  }

  /**
   * Mirror the filter used by the GMV Bundle Options widget
   * (widget/src/components/CustomNameNumber.vue → handleNameInput):
   *   - allow only Unicode letters, whitespace, apostrophe, hyphen, period, tilde
   *   - uppercase
   *   - max 9 characters (same default as the widget; the widget may further
   *     clamp to 5 for Mini Kit — that's handled on the PDP side).
   * Keeping these rules in sync prevents values like "Sunny.go" from being
   * accepted by the form only to be silently mangled to "SUNNYO" when
   * autofilled into the PDP's Add name field.
   */
  function bindJerseyNameAllowedOnly(form) {
    var input = form.querySelector('input[name="jersey_name"]');
    if (!input) return;

    var MAX_LEN = 9;
    var ALLOWED_RE = /[^A-Za-z '.~-]/g;

    function sanitize() {
      var cleaned = (input.value || '')
        .replace(ALLOWED_RE, '')
        .toUpperCase()
        .slice(0, MAX_LEN);
      if (input.value !== cleaned) input.value = cleaned;
    }

    input.setAttribute('maxlength', String(MAX_LEN));
    input.addEventListener('input', sanitize);
    input.addEventListener('paste', function () {
      setTimeout(sanitize, 0);
    });
    input.addEventListener('blur', sanitize);
  }

  function encodeVideoUrl(videoUrl, key) {
    if (!videoUrl) return '';
    try {
      var raw = String(videoUrl) + '|' + String(key || '');
      return btoa(unescape(encodeURIComponent(raw)));
    } catch (e) {
      return btoa(String(videoUrl));
    }
  }

  function decodeVideoUrl(encodedVideo, key) {
    if (!encodedVideo) return '';
    try {
      var decoded = decodeURIComponent(escape(atob(String(encodedVideo))));
      var suffix = '|' + String(key || '');
      if (decoded.slice(-suffix.length) === suffix) return decoded.slice(0, -suffix.length);
      return '';
    } catch (e) {
      return '';
    }
  }

  function saveSubmitCache(payload, videoUrl) {
    var cacheKey = 'idomoo_submit_payload';
    var cacheValue = JSON.stringify({
      payload: payload || {},
      videoUrl: videoUrl || '',
      submittedAt: new Date().toISOString()
    });

    try { localStorage.setItem(cacheKey, cacheValue); } catch (e) {}
    try { sessionStorage.setItem(cacheKey, cacheValue); } catch (e) {}
    try {
      document.cookie = cacheKey + '=' + encodeURIComponent(cacheValue) + '; path=/; max-age=86400; SameSite=Lax';
    } catch (e) {}
  }

  function init() {
    var forms = document.querySelectorAll('form.idomoo-form--triple-api');
    forms.forEach(function (form) {
      bindJerseyNumberNumericOnly(form);
      bindJerseyNameAllowedOnly(form);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var wrapper = form.closest('.idomoo-form__form-wrap');
        var backendUnifiedUrl = wrapper && wrapper.getAttribute('data-backend-unified-url');
        var backendCrmUrl = wrapper && wrapper.getAttribute('data-backend-crm-url');
        var backendApiKey = wrapper && wrapper.getAttribute('data-backend-api-key');
        var successRedirectUrl = wrapper && wrapper.getAttribute('data-success-redirect-url');
        var localeRootUrl = (wrapper && wrapper.getAttribute('data-locale-root-url')) || '';
        var btn = form.querySelector('.idomoo-form__submit');
        var payload = getPayload(form);
        var submitStartedAt = Date.now();
        if (window.GMVCRMTracker && typeof window.GMVCRMTracker.installNetworkMonitor === 'function') {
          window.GMVCRMTracker.installNetworkMonitor();
        }
        if (btn) btn.disabled = true;

        clearFieldErrors(form);
        hideMessage(form);
        var messages = getFormMessages(wrapper);
        var validationErrors = validatePayload(payload, messages);
        if (validationErrors) {
          validationErrors.forEach(function (err) {
            showFieldError(form, err.field, err.message);
          });
          if (btn) btn.disabled = false;
          return;
        }
        if (!backendUnifiedUrl || !backendUnifiedUrl.trim()) {
          showMessage(form, 'error', 'Backend URL not configured.');
          if (btn) btn.disabled = false;
          return;
        }
        saveSubmitCache(payload, '');

        function doRedirect(videoUrl) {
          if (btn) btn.disabled = true;
          saveSubmitCache(payload, videoUrl || '');
          var baseUrl = (successRedirectUrl && successRedirectUrl.trim()) ? successRedirectUrl.trim() : '/personalization/detail';
          var path = baseUrl.split('?')[0].split('#')[0].replace(/\/$/, '');
          var localePrefix = localeRootUrl.replace(/\/$/, '');
          var redirectUrl = localePrefix + path;

          /* Attach video_url + jersey personalisation as query params so the
             destination page works the same whether it's reached via this
             form (cookie+localStorage available) or via a direct/shared
             Idomoo link (only the URL is available). The video page reads
             ?video_url= / ?preferred_name= / ?preferred_number= directly,
             with the cookie path kept as a fallback.

             video_url is appended raw (un-encoded) to mirror the format
             Idomoo's own templated links use (?url=https://e.idomoo.com/...).
             Idomoo URLs only contain `:` `/` `.` and alphanumerics, so they
             survive a query string without escaping. preferred_name still
             goes through encodeURIComponent because jersey names may
             contain spaces (e.g. "VAN DIJK") which would otherwise break
             query string parsing. preferred_number is digits-only so it's
             safe raw. */
          var qs = [];
          if (videoUrl) qs.push('video_url=' + videoUrl);
          if (payload.jersey_name) qs.push('preferred_name=' + encodeURIComponent(payload.jersey_name));
          if (payload.jersey_number) qs.push('preferred_number=' + payload.jersey_number);
          if (qs.length) redirectUrl += '?' + qs.join('&');

          window.location.href = redirectUrl;
        }
        function sendSfdcAfterApiSuccess() {
          var tracker = window.GMVCRMTracker;
          var crmStartedAt = Date.now();
          if (!tracker || typeof tracker.submitSfdcForm !== 'function') {
            console.warn('[CRM] GMVCRMTracker not available – SFDC submission skipped. Is gmv-crm-tracker.js loaded?');
            return Promise.resolve({ startedAt: crmStartedAt, result: null });
          }
          return tracker.submitSfdcForm({
            baseUrl: 'https://sententertainment.my.site.com/lp',
            formId: form.id || '',
            formData: payload
          }).then(function (result) {
            console.log('[CRM] SFDC submit success', result);
            return { startedAt: crmStartedAt, result: result };
          }).catch(function (err) {
            console.error('[CRM] SFDC submit failed', err);
            return {
              startedAt: crmStartedAt,
              result: {
                transport: 'direct-submit',
                ok: false,
                status: err && typeof err.status === 'number' ? err.status : 0,
                error: err && err.message ? err.message : 'Failed to submit SFDC form',
                response: err && err.response ? err.response : null
              }
            };
          });
        }
        function reportCrmResult(crmStartedAt, fallbackNetworkResult) {
          var tracker = window.GMVCRMTracker;
          if (!tracker || typeof tracker.reportSubmission !== 'function') {
            console.warn('[CRM] GMVCRMTracker not available – CRM report skipped. Is gmv-crm-tracker.js loaded?');
            return Promise.resolve(null);
          }
          return tracker.reportSubmission({
            startedAt: crmStartedAt || submitStartedAt,
            waitTimeoutMs: 1800,
            apiUrl: backendCrmUrl || '/api/crm',
            apiKey: backendApiKey && backendApiKey.trim(),
            idForm: form.id || '',
            email: payload.email || '',
            request: payload,
            networkResultOverride: fallbackNetworkResult || null
          }).then(function (result) {
            console.log('[CRM] report sent', result);
            return result;
          }).catch(function (err) {
            console.error('[CRM] report failed', err);
            return null;
          });
        }
        /* State persisted on success (every submit replaces the previous value):
             - localStorage['idomoo_submit_payload']
             - sessionStorage['idomoo_submit_payload']
             - cookie "idomoo_submit_payload" (1d, SameSite=Lax)
           The destination page (gmv-idomoo-video.liquid) prefers the
           ?video_url=/?preferred_name=/?preferred_number= query params
           appended in doRedirect() and falls back to the cookie when the
           URL is bare (e.g. user opens a fresh tab or shared a clean link).
           encodeVideoUrl/decodeVideoUrl are kept for potential future use
           but are not part of the current redirect flow. */

        
        var url = backendUnifiedUrl.trim();
        var headers = { 'Content-Type': 'application/json' };
        if (backendApiKey && backendApiKey.trim()) headers['X-API-Key'] = backendApiKey.trim();
        var bodyJson = JSON.stringify(payload);
        var curlBody = bodyJson.replace(/'/g, "'\\''");
        console.log('[Idomoo Form] POST', url, payload);
        var curlCmd = 'curl -X POST "' + url + '" \\\n  -H "Content-Type: application/json"';
        if (backendApiKey && backendApiKey.trim()) curlCmd += ' \\\n  -H "X-API-Key: ' + backendApiKey.trim().replace(/"/g, '\\"') + '"';
        console.log('[Idomoo Form] curl:\n' + curlCmd + ' \\\n  -d \'' + curlBody + '\'');
        fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) {
              if (!res.ok) {
                console.error('[Idomoo Form] fetch error:', res.status, res.statusText, json);
                throw new Error(json.error || 'Request failed ' + res.status);
              }
              return json;
            });
          })

          /* start for debugging */
          /*Promise.resolve({
            success: true,
            videoUrl: 'https://e.idomoo.com/21716/0000/mqd1n3jqm2cx1l26q1ab1gj2om142u33272wtdum10212b.mp4'
          })*/
          /* end for debugging */
          .then(function (json) {
            if (json.success !== true) throw new Error(json.error || 'Request failed');
            var videoUrl = (json.videoUrl || '').trim();
            if (!videoUrl) throw new Error(messages.videoUrlMissing);
            return sendSfdcAfterApiSuccess().then(function (crmMeta) {
              return reportCrmResult(crmMeta && crmMeta.startedAt, crmMeta && crmMeta.result).then(function () {
                doRedirect(videoUrl);
              });
            });
          })
          .catch(function (err) {
            console.error('[Idomoo Form] error:', err);
            if (btn) btn.disabled = false;
            clearFieldErrors(form);
            showMessage(form, 'error', err && err.message ? err.message : 'Something went wrong. Please try again.');
          });
        return false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
